
import { Component, Vue } from "vue-property-decorator";
import { EventBus, getAPIAuthorizedHeader } from "@/services/common";
import VueNumeric from "vue-numeric";
import Axios from "axios";
import { API_STORE } from "@/config";
import { AddBalance } from "@/models/common";
import Swal from "sweetalert2";

@Component({ components: { VueNumeric } })
export default class AddBalanceComponent extends Vue {
  public addBalance = new AddBalance();
  public disableSubmitbutton = false;

  public async validateAndAdd() {
    let valid = await this.$validator.validateAll();
    if (valid) {
      this.disableSubmitbutton = true;
      this.$showLoader(true);
      let response = await Axios.post(
        API_STORE.PORTAL + "addBalance",
        { ...this.addBalance, ...{ userId: this.$userId } },
        {
          headers: getAPIAuthorizedHeader(),
        }
      );
      this.disableSubmitbutton = false;
      this.$showLoader(false);
      if (response && response.data) {
        Swal.fire({
          position: "center",
          icon: "success",
          title: response.data.message,
          showConfirmButton: true,
        });
        EventBus.$emit("updateWalletAmount", {
          amount: this.addBalance.amount,
        });
        this.$router.push("/superAdmin");
      }
    }
  }
}
